import AxiosService from 'services/axios-service';
import { CONSULT, DOC_MATRIX, PERSIST, SELF_DOCS, TDI, PROFILE } from '../variables/api-path-list';
import { Request } from './request-utils';
import { OFFER } from '../variables/document-matrix';
import { keycloakService } from '../services/keycloak-service';
import { take } from 'rxjs/operators';
import { cloneObject } from '../utils';
import { APP_METADATA_ENDPOINT } from 'config';
import { PERSIST_CA, PERSIST_CERT, PERSIST_KEY } from '../config';

let hash = require('object-hash');

const axios = AxiosService.getInstance();
const request = new Request();
const temporaryValidToken = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJFVVY1STlYOUktZW9PUVpUcm0teWdBdklLY2Q5enMtZXUzNFJPLXZ2dE53In0.eyJqdGkiOiJlM2QzMzdkZi05MDU4LTQ4NTYtOTI3Ny1kMzQ2YmU2MTYyNGYiLCJleHAiOjE1NzkxMDc2MjksIm5iZiI6MCwiaWF0IjoxNTc5MTA2NzI5LCJpc3MiOiJodHRwczovL2RuYnRpbS5sYXRhbGx5bmlzLmdlbWFsdG8uY29tL2F1dGgvcmVhbG1zL1RJTS1UREktVjEiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiZDJiMmI5ZDItMWIyZi00MmQ4LThmYTAtZjVlZThkMGE2OTQ3IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoid2ViYXBwIiwibm9uY2UiOiJhNjA5MmQzYi0wZDZmLTQ3MzQtOGQ1My1kMTczODk0MjYwYjQiLCJhdXRoX3RpbWUiOjE1NzkxMDU0NjgsInNlc3Npb25fc3RhdGUiOiJhNTNlZDg3MS02YTZlLTQwNmMtOGU1YS1kMTQwYzBkZDAzNDkiLCJhY3IiOiIwIiwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIlBhcnRuZXItQ2FwdHVyZS1TdXBlcnZpc29yIiwid3JpdGVfbWFpbCIsIm9mZmxpbmVfYWNjZXNzIiwicmVhZF9wYWNrYWdlIiwicGFydG5lcl9jYXB0dXJlIiwidXBkYXRlX3BhY2thZ2UiLCJyZWFkX2RteCIsInNjczpleGVjdXRlU2NlbmFyaW8iLCJ0aGFsZXNfdGVzdGVyIiwid3JpdGVfcGFja2FnZSIsInVtYV9hdXRob3JpemF0aW9uIiwib3JnX2FjY2Vzc19sZXZlbCJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIHByb2ZpbGUiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsInJvbGVzIjpbIlBhcnRuZXItQ2FwdHVyZS1TdXBlcnZpc29yIiwid3JpdGVfbWFpbCIsIm9mZmxpbmVfYWNjZXNzIiwicmVhZF9wYWNrYWdlIiwicGFydG5lcl9jYXB0dXJlIiwidXBkYXRlX3BhY2thZ2UiLCJyZWFkX2RteCIsInNjczpleGVjdXRlU2NlbmFyaW8iLCJ0aGFsZXNfdGVzdGVyIiwid3JpdGVfcGFja2FnZSIsInVtYV9hdXRob3JpemF0aW9uIiwib3JnX2FjY2Vzc19sZXZlbCJdLCJuYW1lIjoiVml2aWFuIEtpbWllIElzdXlhbWEiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ2aXN1eWFtYSIsImdpdmVuX25hbWUiOiJWaXZpYW4iLCJmYW1pbHlfbmFtZSI6IktpbWllIElzdXlhbWEiLCJlbWFpbCI6InZpdmlhbi5pc3V5YW1hQHRoYWxlc2dyb3VwLmNvbSJ9.GYqMGMAl9N0qJ7_Ls6EObsvs1FmaCLSip1zZPda1VHOFqBSHefI4laYiy_I_SZ9ahkc4ISSo7sOyGuOfynTO3DgGTgndxWXUgVkVXhjJiS6WLgcrCCCKtOm9UI_h4oXrZxorcibYZOk7nyMKt-6KKCYbz2eT0fLanD5C85GONBu4Y96Gbii7YUO4DJPNbJtzbsiXl4hVr61xyrby8yIklSDipvGTZw6pE4PYyomn46zmRbStXNJ_Vcz6y4SOEsGE28pfeRDnXanQSXZPiRMdgUsCKqJuzX-GfuXVFK-EIEe8ft2DqQRfmIejACbaFk-fJvz5Vs9BdaUUGYLFS1Iisg';
const content_type = 'application/json';

export function getSaleTypeForm(payload) {
  let cloned_payload = cloneObject(payload);
  delete cloned_payload[OFFER];
  return request.post(DOC_MATRIX.SALE_TYPE(null, { md5: hash(cloned_payload) }), payload).then(res => {
    return res.data;
  });
}


export function getSaleTypeForm2(payload) {
  let cloned_payload = cloneObject(payload);
  delete cloned_payload[OFFER];
  return request.post(DOC_MATRIX.SALE_TYPE_2(null, { md5: hash(cloned_payload) }), payload).then(res => {
    return res.data;
  });
}

export function getSaleTypeForm3(payload) {
  let cloned_payload = cloneObject(payload);
  delete cloned_payload[OFFER];
  return request.post(DOC_MATRIX.SALE_TYPE_3(null, { md5: hash(cloned_payload) }), payload).then(res => {
    return res.data;
  });
}

export function getSaleTypeForm4(payload) {
  let cloned_payload = cloneObject(payload);
  delete cloned_payload[OFFER];
  return request.post(DOC_MATRIX.SALE_TYPE_4(null, { md5: hash(cloned_payload) }), payload).then(res => {
    return res.data;
  });
}

export function getProfile() {
  return request.get(PROFILE.PROFILE(null)).then(res => res.data);
}

export function getDocumentForm(payload) {
  return request.post(DOC_MATRIX.DOCUMENT_LIST(null, { md5: hash(payload) }), payload).then(res => res.data);
}

export function getStatusColor(status) {
  return request.get(DOC_MATRIX.STATUS_COLOR({ status: status }));
}

export function getUpdatableStatus(status) {
  return request.get(CONSULT.UPDATABLE_STATUS({ status: status }));
}

export function updateStatus(payload) {
    return request.put(CONSULT.UPDATE_STATUS(), payload);
}

export function getAppMetadata() {
  return request.get(APP_METADATA_ENDPOINT).then(res => res.data, error => null);
}

export function postPackagePersist(payload) {
  const https = require('https-browserify');
  return new Promise(resolve => {
    keycloakService.getToken().pipe(
      take(1)
    ).subscribe(
      (token) => {
        const config = {
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': content_type
          }
        };
        const httpsAgent = new https.Agent({
          cert: PERSIST_CERT,
          key: PERSIST_KEY,
          ca: PERSIST_CA
        });
        resolve(axios.post(PERSIST.PACKAGE(), { httpsAgent }, payload, config).then((response) => response));
      });
  });
}

export function createTDIScenario(payload, firebaseToken) {
  return new Promise(resolve => {
    keycloakService.getToken().pipe(
      take(1)
    ).subscribe(
      (token) => {
        const config = {
          headers: {
            'X-OL-Push-Token': firebaseToken,
            'X-OL-Channel': 'WebApp',
            'Authorization': 'Bearer ' + token,
            'Content-Type': content_type
          }
        };
        resolve(axios.post(TDI.SCENARIO(), payload, config).then((response) => response));
      });
  });
}


export function TDIStep(payload, scenarioId, stepId) {
  return new Promise((resolve, reject) => {
    keycloakService.getToken().pipe(
      take(1)
    ).subscribe(
      (token) => {
        const config = {
          headers: {
            'X-OL-Channel': 'WebApp',
            'Authorization': 'Bearer ' + token,
            'scenarioId': scenarioId,
            'Content-Type': 'application/json',
            'stepId': stepId
          }
        };
        axios.patch(TDI.SCENARIO_STEP({
          scenarioId: scenarioId,
          stepId: stepId
        }), payload, config).then(
          response => resolve(response.data)
        ).catch(function(error) {
          if (error.response) {
            reject(error);
          }
        });
      });
  });
}

export function TDIStatus(scenarioId) {
  return new Promise(resolve => {
    keycloakService.getToken().pipe(
      take(1)
    ).subscribe(
      (token) => {
        const config = {
          headers: {
            'X-OL-Channel': 'WebApp',
            'Authorization': 'Bearer ' + token
          }
        };
        resolve(axios.get(TDI.SCENARIO_STATUS({ scenarioId: scenarioId }), config).then(response => response.data));
      });
  });
}

export function getPackages(params) {
  return request.get(CONSULT.PACKAGE(null, params)).then(res => res.data);
}

export function getExport(params) {
    return request.get(CONSULT.EXPORT(null, params)).then(res => res.data);
}

export function getFilters() {
  return axios.get(SELF_DOCS.FILTER_LIST()).then(res => res.data);
}

export function getDocument(packageId, fileId) {
  return request.get(CONSULT.FILE({ packageId: packageId, fileId: fileId })).then(res => res.data);
}

export function getHelpFile() {
    return request.get(DOC_MATRIX.GET_HELP_FILE()).then(res => res.data);
}

export function getDocs(operacao){
  return request.post(DOC_MATRIX.DOCUMENT_LIST(), { USECASEID: operacao }).then(res => {
    return res.data;
  });
}

export function getZip(packageId) {
  return request.post(CONSULT.ZIP(), { packageId: packageId }).then(res => res.data);
}

export function getPdf(packageId) {
    return request.post(CONSULT.PDF(), { packageId: packageId }).then(res => res.data);
}

export function createDocument(packageId, payload) {
  return request.post(CONSULT.DOCUMENT({ packageId: packageId, idDocument: '' }), payload).then(res => res.data);
}

export function updateDocument(packageId, idDocument, payload) {
  return request.put(CONSULT.DOCUMENT({ packageId: packageId, idDocument: idDocument }), payload).then(res => res.data);
}

export function deleteDocument(packageId, idDocument) {
  return request.delete(CONSULT.DOCUMENT({ packageId: packageId, idDocument: idDocument })).then(res => res.data);
}

export function getKeys() {
  return request.get(DOC_MATRIX.GET_KEYS()).then(res => res.data);
}